module.exports = __webpack_public_path__ + "public/files/img/banner.f8c7598d.png";